import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { LevStandardQueryMeta } from '../../web/ReactQueryProvider';

// Keyed under the donation prefix so invalidateAllDonationFilters reaches it - React Query compares key
// elements strictly, so a '/donation/summary' first element would never match a '/donation' invalidation.
const BASE_API_KEY = '/donation';

const emptySummary: Api.IDonationSummary = {
	totalDonations: 0,
	totalAmount: 0,
	totalDonors: 0,
};

export const useDonationSummaryQuery = ({
	filterRequest,
	enabled,
	refetchOnWindowFocus = false,
	meta,
}: {
	filterRequest: Api.IDonationFilterRequest;
	enabled?: boolean;
	refetchOnWindowFocus?: boolean;
	meta?: LevStandardQueryMeta;
}) => {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		queryFn: async () => {
			const value = await userSession.webServiceHelper.callAsync<Api.IDonationSummary>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `donation/summary`,
				}),
				'POST',
				filterRequest
			);
			return value ?? emptySummary;
		},
		queryKey: [BASE_API_KEY, 'summary', filterRequest],
		refetchOnWindowFocus,
		meta,
	});
};
